import { useNavigate, useParams } from 'react-router-dom'

import { ItManagementPaymentDetailsPageDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import Sidepanel from 'modules/core/components/Sidepanel'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { transactionTypeWithCard } from 'modules/expenses/lib/transactions/transactionTypeWithCard'
import TransactionDetailContent, {
  PaymentDetail,
} from 'modules/it_management/components/ApplicationDetailsContent/TransactionDetailContent'
import { TABS } from 'modules/it_management/lib/tabs'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import InvoiceDetailContent from '../components/ApplicationDetailsContent/InvoiceDetailContent'

const PaymentDetailsPage = () => {
  const { application_id, paymentId } = useParams()
  const { navigation } = useNavigation()
  const { company } = useCurrentSession()
  const navigate = useNavigate()

  const { data, loading } = useQuery(ItManagementPaymentDetailsPageDocument, {
    variables: { companyId: company.id, id: Number(paymentId) },
  })

  const onClose = () => {
    navigate(
      navigation.software.applications.applicationId.fullPath({
        application_id: Number(application_id),
      }) +
        '?tabs=' +
        TABS.SPENDS
    )
  }

  const { cardPayment, invoice } = data?.itManagement.softwarePayment || {}

  let paymentDetail: PaymentDetail | undefined

  if (cardPayment) {
    paymentDetail = {
      id: cardPayment.id,
      cardAlias: cardPayment.card?.alias,
      date: cardPayment.externalCreatedAt,
      ownerName: cardPayment.card?.cardholder.employee?.fullName,
      merchantName: cardPayment.merchantName,
      merchantAmountCents: cardPayment.merchantAmountCents,
      merchantCurrency: cardPayment.merchantCurrency,
      amountCents: cardPayment.amountCents,
      currency: cardPayment.currency,
      exchangeRate: cardPayment.exchangeRate,
      type: transactionTypeWithCard(cardPayment.card),
    }
  }

  return (
    <ResponsivePage.Body variant="wide" showHeader={false}>
      <Sidepanel
        overlay
        boxPadding
        width="wide"
        title={i18n.t('it_management.software_setups.software_payment_detail.title')}
        onClose={onClose}
        open
        headerBorder
        closeLabel={i18n.t('common.close')}
        locked
      >
        {loading && <Loading />}

        {!loading && paymentDetail && <TransactionDetailContent paymentDetail={paymentDetail} />}
        {!loading && !!invoice && <InvoiceDetailContent invoice={invoice} />}
      </Sidepanel>
    </ResponsivePage.Body>
  )
}

export default PaymentDetailsPage
